import { Directive, Input, ElementRef, AfterViewInit, OnDestroy, NgZone, ChangeDetectorRef, Injector } from '@angular/core';
import { GaugeSettings } from '../models/gauge-settings.model';

@Directive({
  selector: '[appResponsiveGauge]'
})
export class ResponsiveGaugeDirective implements AfterViewInit, OnDestroy {
  @Input('appResponsiveGauge') config!: GaugeSettings;
  @Input() gauge!: any; // ngx-gauge referencia

  private resizeObserver!: ResizeObserver;
  private debounceTimeout: any;
  private prevSize: number | null = null;

  constructor(private el: ElementRef, private ngZone: NgZone, private injector: Injector) {}

  ngAfterViewInit(): void {
    // ResizeObserver futtatása Angular-on kívül
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => this.debounceUpdate());
      this.resizeObserver.observe(this.el.nativeElement);
    });

    // Első beállítás késleltetéssel, hogy a view teljesen inicializálódjon
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateGaugeSize(), 0);
    });
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

  public debounceUpdate() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => this.updateGaugeSize(), 150); // Növelt debounce idő a jobb teljesítményért
  }

  private updateGaugeSize() {
    if (!this.config?.breakpoints || !this.gauge || !this.el.nativeElement.offsetWidth) return;

    const width = this.el.nativeElement.offsetWidth;
    const matched = this.config.breakpoints.find(bp => width <= bp.maxWidth);

    if (matched && matched.size !== this.prevSize) {
      this.prevSize = matched.size;
      this.ngZone.run(() => {
        this.gauge.size = matched.size;
        // Trigger change detection az ngx-gauge számára
        if (this.gauge.ngOnChanges) {
          this.gauge.ngOnChanges({
            size: {
              currentValue: matched.size,
              previousValue: this.prevSize,
              firstChange: false,
              isFirstChange: () => false
            }
          });
        }
        // Alternatív megoldás change detection triggerelésére
        const cdr = this.injector.get(ChangeDetectorRef, null, { optional: true });
        if (cdr) {
          cdr.detectChanges();
        }
      });
    }
  }
}
